import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=037e435e&scoped=true"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"
import style0 from "./CoursesList.vue?vue&type=style&index=0&id=037e435e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e435e",
  null
  
)

export default component.exports